import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";import {useNavigate} from "react-router-dom";
import {UserPermission} from "../../utils/utils";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;
const PaymentMethodList = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [paymentMethods, setPaymentMethods] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethods/query=' + (query && query !== '' ? (query) : '');
            setLoading(true);
            const response = await makeRequest(url, 'GET');
            setPaymentMethods(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };


    async function removePaymentMethod(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethods/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_PAYMENT_METHOD) === false) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Consulta de Formas de Pagamento</div>
                {hasUserPermission(UserPermission.CREATE_PAYMENT_METHOD) &&
                    <button className={"new-button"} onClick={() => navigate('/app/paymentmethod')}>Novo</button>
                }
            </div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
            </div>
            <table style={{width: '540px'}}>
                <colgroup>
                    <col style={{width: '100px'}}/>
                    <col style={{width: '440px'}}/>
                    <col style={{width: 'auto'}}/>
                </colgroup>

                <thead>
                <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th/>
                </tr>
                </thead>

                <tbody style={{overflowY: 'auto'}}>
                {paymentMethods.map((paymentMethod, index) => (
                    <tr key={index}>
                        <td>{paymentMethod.code}</td>
                        <td>{paymentMethod.name}</td>
                        <td>
                            <div style={{display: 'flex'}}>
                                {
                                    hasUserPermission(UserPermission.EDIT_PAYMENT_METHOD) &&
                                    <button onClick={async () => {
                                        await navigate('/app/paymentmethod?id=' + paymentMethod.id);
                                    }}>Editar
                                    </button>
                                }
                                {hasUserPermission(UserPermission.REMOVE_PAYMENT_METHOD) &&
                                    <button
                                        className="remove-button"
                                        onClick={async () => {
                                            if (window.confirm('Deseja realmente excluir?')) {
                                                await removePaymentMethod(paymentMethod.id);
                                            }
                                        }}
                                    >
                                        Excluir
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>
                ))}
                {paymentMethods.length === 0 && <tfoot>Nenhum item encontrado.</tfoot>}
                </tbody>
            </table>
        </>
    );
};

export default PaymentMethodList;
